import * as React from 'react';
import { ModalWindow, UIHeading1, UIHeading2, UIText1, UIText2 } from '@cian/ui-kit';

import * as styles from './ContactsModalWindow.css';
import { formatPhone } from './utils/formatPhone';

export interface IContactsModalWindowProps {
  onClose: () => void;
  open: boolean;
  phone: string | null;
}

export const ContactsModalWindow: React.FC<IContactsModalWindowProps> = ({ onClose, open, phone }) => {
  const title = 'Контакты консультанта';

  const getFormattedPhone = React.useCallback((phone: string) => {
    const formattedPhone = formatPhone(phone);

    return <span data-testid="ContactPhone">{formattedPhone}</span>;
  }, []);

  return (
    <ModalWindow escape onClose={onClose} open={open} outside print size="M" width={465}>
      <div className={styles['content']} data-testid="ContactsModalContent">
        <UIHeading2>{title}</UIHeading2>
        <div className={styles['phone-wrapper']}>{phone && <UIHeading1>{getFormattedPhone(phone)}</UIHeading1>}</div>
        <UIText2 color="gray60_100">Режим работы с 09:00 до 18:00</UIText2>
        <div className={styles['info']}>
          <div className={styles['image']} />
          <div className={styles['text']}>
            <div className={styles['consultant-label']}>Консультант</div>
            <UIText1 fontWeight="bold">Циан</UIText1>
          </div>
        </div>
      </div>
    </ModalWindow>
  );
};
